import {Directive, Injector, Input, OnChanges, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {takeUntil, tap} from 'rxjs/operators';
import {TypedSimpleChanges} from '../../common/typed-on-changes';
import {TextHidingDirective} from '../../directives/text-hiding';
import {destroy$} from '../destroyable';
import {TooltipDirective} from './tooltip.directive';

@Directive({
    selector: '[textHiding][tooltip],[textHiding][tooltipL10n]',
    standalone: false
})
export class TextHidingWithTooltipDirective implements OnInit, OnChanges {

    @Input()
    public tooltipAlwaysEnabled: boolean = false;

    public textHidingDirective: TextHidingDirective;
    public tooltipDirective: TooltipDirective;

    public readonly destroy$ = destroy$();

    private subscriptionToOverflow: Subscription;

    constructor(
        private injector: Injector
    ) {}

    public ngOnInit(): void {
        this.tooltipDirective = this.tooltipDirective
            || this.injector.get(TooltipDirective, null, {host: true});

        if (!this.tooltipAlwaysEnabled) {
            this.bindToOverflow();
        }
    }

    public ngOnChanges(changes: TypedSimpleChanges<TextHidingWithTooltipDirective>): void {
        if (changes.tooltipAlwaysEnabled) {
            this.tooltipDirective = this.tooltipDirective
                || this.injector.get(TooltipDirective, null, {host: true});

            if (!!changes.tooltipAlwaysEnabled.previousValue !== !!changes.tooltipAlwaysEnabled.currentValue) {
                if (this.tooltipAlwaysEnabled) {
                    this.unbindFromOverflow();
                } else if (!this.tooltipAlwaysEnabled) {
                    this.bindToOverflow();
                }
            }
        }
    }

    private bindToOverflow(): void {
        if (!this.subscriptionToOverflow) {
            this.textHidingDirective = this.textHidingDirective
                || this.injector.get(TextHidingDirective, null, {host: true});

            this.subscriptionToOverflow = this.textHidingDirective.isOverflowed$.pipe(
                tap(isOverflowed => this.tooltipDirective.isEnabled$.next(isOverflowed)),
                takeUntil(this.destroy$)
            ).subscribe();
        }
    }

    private unbindFromOverflow(): void {
        if (this.subscriptionToOverflow) {
            this.subscriptionToOverflow.unsubscribe();
            this.subscriptionToOverflow = undefined;
            this.tooltipDirective.isEnabled$.next(true);
        }
    }

}
